import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Input,
  CustomInput,
  DropdownItem,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import get from 'lodash/get'
import find from 'lodash/find'
import styled from 'styled-components'
import shortid from 'shortid'

class AutoFillManDaysForm extends React.Component {
  state={ tempSearch: '' }

  filterResource = (element) => {
    const auto_fill_search = get(this.props, 'auto_fill_search', '')
    if (this !== '' && element) {
      const name = element.name.toLowerCase()
      return name.includes(auto_fill_search.toLowerCase())
    } return element
  }

  renderResourceName = () => {
    const list = []
    const resources = get(this.props, 'resources')
    const employees = get(this.props, 'employees')
    if (resources && employees) {
      resources.map(r => {
        const user = find(employees, {
          _id: r.user_id,
        })
        if (user) {
          const user_name = `${user.emp_code} - ${user.first_name} ${user.last_name} (${user.nick_name})`
          list.push({ name: user_name, user_id: user._id })
        }
        return null
      })
    }
    return list
  }

  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    const auto_fill_start_date = get(this.props, 'auto_fill_start_date')
    const auto_fill_end_date = get(this.props, 'auto_fill_end_date')
    const working_day = get(this.props, 'working_day')
    const specific_working_day = get(this.props, 'specific_working_day')
    const maximum_working_day = get(this.props, 'maximum_working_day')
    const handleClickAll = get(this.props, 'handleClickAll')
    const handleClickNone = get(this.props, 'handleClickNone')
    const handleSearch = get(this.props, 'handleSearch')
    const handleInput = get(this.props, 'handleInput')
    const handleChangeStartDate = get(this.props, 'handleChangeStartDate')
    const handleChangeEndDate = get(this.props, 'handleChangeEndDate')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        size='lg'
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader toggle={ get(this.props, 'toggle') }>
          <HeadLabel>Auto Fill Man-Days</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row>
                      <Col sm={ 6 }>
                        <Row>
                          <Col>
                            <TypeLabel>Select&nbsp;
                              <ClickableText
                                onClick={ () => handleClickAll() }
                              >All</ClickableText>
                              /
                              <ClickableText
                                onClick={ () => handleClickNone() }
                              >None
                              </ClickableText>
                            </TypeLabel>&nbsp;
                            <TypeLabel>&nbsp;{`(Selected ${get(this.props, 'auto_fill_man_days.length', 0)})`}</TypeLabel>&nbsp;
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <SearchField
                              onChange={ (e) => {
                                if (e.target.value === '') handleSearch(e.target.value)
                                this.setState({ tempSearch: e.target.value })
                              } }
                              onKeyDown={ (e) => {
                                if (e.keyCode === 13) handleSearch(this.state.tempSearch)
                              } }
                            />
                          </Col>
                        </Row>
                        <DropdownItem divider />
                        <List>
                          { this.renderResourceName()
                            .filter(this.filterResource).map((res) => {
                              return (
                                <CustomCheckboxInput
                                  key={ shortid() }
                                  id={ shortid() }
                                  type="checkbox"
                                  name={ res.name }
                                  label={ res.name }
                                  value={ res.user_id }
                                  checked={ get(this.props, 'auto_fill_man_days').includes(res.user_id) }
                                  onChange={ (e) => handleInput(e) }
                                />
                              )
                            })
                          }
                        </List>
                      </Col>
                      <Col sm={ 6 }>
                        <Row>
                          <Col>
                            <LabelDetail >Start Month</LabelDetail>
                            <ProjectDatePicker
                              onChange={ (e) => handleChangeStartDate(e) }
                              name="auto_fill_start_date"
                              placeholderText='DD/MM/YYYY'
                              selected={ auto_fill_start_date === '' ? '' : auto_fill_start_date }
                              dateFormat="DD/MM/YYYY"
                              showYearDropdown
                              showMonthDropdown
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <LabelDetail >End Month</LabelDetail>
                            <ProjectDatePicker
                              onChange={ (e) => handleChangeEndDate(e) }
                              name="auto_fill_end_date"
                              placeholderText='DD/MM/YYYY'
                              selected={ auto_fill_end_date === '' ? '' : auto_fill_end_date }
                              dateFormat="DD/MM/YYYY"
                              showYearDropdown
                              showMonthDropdown
                            />
                          </Col>
                        </Row>
                        <LabelDetail >Man-Days (Working days per month)</LabelDetail>
                        <Row>
                          <Col>
                            <CustomRadioInput
                              type="radio"
                              id="maximum_working_day"
                              name="customRadio"
                              label="Maximum Working Day"
                              checked={ maximum_working_day }
                              onChange={ (e) => handleInput(e) }
                            />
                            <TextDetail>
                              Auto fill man-days according to working calendar (Does not count Saturday, Sunday and Holidays)
                            </TextDetail>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <CustomRadioInput
                              type="radio"
                              id="specific_working_day"
                              name="customRadio"
                              label="Specific Working Day"
                              checked={ specific_working_day }
                              onChange={ (e) => handleInput(e) }
                            />
                            <InputField
                              type='number'
                              disabled={ !specific_working_day }
                              name="working_day"
                              value={ working_day }
                              invalid={ working_day > 31 }
                              onChange={ (e) => handleInput(e) }
                            />
                            {
                              working_day > 31
                              && <ErrorMessage>Man-days exceeds this month limit</ErrorMessage>
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AutoFillManDaysForm

const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  color: #AD2624;
`
const List = styled.div`
  font-family: 'Gotham' !important;
  font-size: 12px;
  height: calc(100vh - 500px);
  @media (max-width: 1024px) {
    height: calc(100vh - 400px);
  }
  overflow:scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    width: 11px;
  }
  ::-webkit-scrollbar:horizontal {
    height: 11px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
  }
`
const TextDetail = styled.p`
  font-family: 'Gotham' !important;
  font-size: 12px;
`
const LabelDetail = styled(Label)`
  font-family: 'Gotham' !important;
  font-size: 12px;
`
const TypeLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const SearchField = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: auto;
  margin-left: 2% !important;
  box-sizing: border-box;
`
const CustomRadioInput = styled(CustomInput)`
  font-family: 'Gotham-Bold' !important;
`
const CustomCheckboxInput = styled(CustomInput)`
  font-family: 'Gotham' !important;
  font-size: 15px;
  margin-bottom: 5% ;
`
const ProjectDatePicker = styled(DatePicker)`
  font-family: 'Gotham' !important;
  width : 216px ;
  height : 30px ;
  font-size: 12px ;
  padding-left: 5%;
  float: right;
  border-radius: 5px;
  /* ::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
  } */
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
  @media (max-width: 575.98px) {
    width: 100%;
  }
`
const ClickableText = styled.span`
  cursor: pointer;
  text-decoration: underline;
`
const ErrorMessage = styled.p`
  font-family: 'Gotham-Light' !important;
  // word-break: break-all;
  // white-space: normal;
  font-size: 10px ;
  color: red;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/auto-fill-man-days/index.js